/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type GetApiSentEmailListSortDirection = typeof GetApiSentEmailListSortDirection[keyof typeof GetApiSentEmailListSortDirection] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiSentEmailListSortDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;
